import React from 'react';
import { useGlobalMarquee } from '../../hooks/useGlobalMarquee';
import { MarqueeBanner } from './MarqueeBanner';

/**
 * App-wide marquee (Admin → System Settings). Shown on every dashboard page when enabled.
 */
const GlobalMarquee: React.FC = () => {
  const { enabled, text } = useGlobalMarquee();

  if (!enabled || !text?.trim()) {
    return null;
  }

  return <MarqueeBanner text={text} variant="global" />;
};

export default GlobalMarquee;
